import React from 'react';
import { IonPage } from '@ionic/react';

import { Flex } from 'Components/Base';
import Loading from 'Components/Loading';
import EmptyCourses from 'Containers/EmptyCourses';
import { useConfig } from 'Context/ConfigContext';
import { useAllMyCoursesData, MY_COURSES_MODE } from 'Domain/MyCourseData';

import FeatureAnnouncement from './Containers/FeatureAnnouncement';
import FeatureAnnouncementByUserType from './Containers/FeatureAnnouncementByUserType';
import FullScreenMyCourses from './FullScreenMyCourses';
import FixedSidebarMyCourses from './FixedSidebarMyCourses';

const MY_COURSE_PAGE = {
  withFixedSidebar: FixedSidebarMyCourses,
  fullscreen: FullScreenMyCourses,
};

const MyCourses = (props) => {
  const { data: myCourses, loading } = useAllMyCoursesData({ mode: MY_COURSES_MODE.ALL });
  const {
    myCourses: { enableFullScreenEmptyCourses, layoutType },
  } = useConfig();

  if (loading) {
    return (
      <Flex justifyContent={'center'} alignItems={'center'} width={1} height={'100vh'}>
        <Loading />
      </Flex>
    );
  }

  if (enableFullScreenEmptyCourses && myCourses?.length === 0) {
    return (
      <IonPage>
        <EmptyCourses {...props} pt={4} />
      </IonPage>
    );
  }

  const MyCoursePage = MY_COURSE_PAGE[layoutType] ?? MY_COURSE_PAGE['fullscreen'];

  return (
    <>
      <IonPage>
        <MyCoursePage />
      </IonPage>
      <FeatureAnnouncement />
      <FeatureAnnouncementByUserType />
    </>
  );
};

export default MyCourses;
